import React, { useEffect, useState } from 'react';

const isFloat = (maybeFloat) => /^[+-]?\d+(\.\d+)?$/.test(maybeFloat);
const isInteger = (maybeNumber) => /^[0-9]*$/.test(maybeNumber);
const isEmail = (maybeEmail) => /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(maybeEmail);
const isMobileNumber = (maybeMobileNumber) => maybeMobileNumber.length === 10 && /^[0-9]*$/.test(maybeMobileNumber) && maybeMobileNumber[0] === '0';
const isCitizenId = (maybeCitizenId) => maybeCitizenId.length === 13 && /^[0-9]*$/.test(maybeCitizenId);
const isPassportId = (maybePassportId) => maybePassportId.length >= 5 && /^[0-9a-zA-Z]*$/.test(maybePassportId);

const FormItem = ({
  label,
  customLabelCss = '',
  htmlFor,
  disabled = false,
  value,
  rule,
  name,
  validationMessages,
  children,
//   onValidationChange,
}) => { 
  const [validationMsg, setValidationMsg] = useState('');

  const validate = () => {
    let res = '';
    if (rule) {
      if (rule.required && (!value || (Array.isArray(value) && value.length === 0))) {
        res = label ? `${label} cannot be empty` : 'Field cannot be empty';
      } else if (value && rule.format === 'email' && !isEmail(`${value}`)) {
        res = 'Invalid email format';
      } else if (value && rule.format === 'mobile' && !isMobileNumber(`${value}`)) {
        res = 'Invalid mobile number format';
      } else if (value && rule.format === 'integer' && !isInteger(`${value}`)) {
        res = 'Invalid number format';
      } else if (value && rule.format === 'float' && !isFloat(`${value}`)) {
        res = 'Invalid number format';
      } else if (value && rule.format === 'citizen' && !isCitizenId(`${value}`)) {
        res = 'Invalid citizen ID format';
      } else if (value && rule.format === 'passport' && !isPassportId(`${value}`)) {
        res = 'Invalid passport ID format';
      }
      if (!res && rule.validator) {
        const vres = rule.validator(value);
        if (vres && vres.error) {
          res = vres.error;
        }
      }
    }
    setValidationMsg(res);
    // onValidationChange(res);
    return res;
  };

  useEffect(() => {
    validate();
  }, [value]);

  return (
    <div className="flex flex-col">
      {label && (
        <label
          htmlFor={htmlFor}
          className={`block text-base font-medium mb-1 xs:whitespace-nowrap ${disabled ? 'text-secondary-text-disabled' : 'text-secondary-label'} ${customLabelCss}`}
        >
          <div className="flex flex-row items-center">
            <div>{label}</div>
            {rule?.required && (
              <div className={disabled ? 'text-secondary-text-disabled' : 'text-danger'}>*</div>
            )}
          </div>
        </label>
      )}
      <div>{children}</div>
      {validationMsg && (
        <div className="w-full text-sm font-normal text-danger flex-wrap break-words mt-1">
          {validationMsg}
        </div>
      )}
    </div>
  );
};

export default FormItem;
